exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".right-part__left {\n    background: rgb(255, 255, 255);\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n\n.error{\n  color: #EA475D;\n}\n\n@media (max-width: 639px) {\n    .right-part__left {\n      /* padding: 0px 16px; */\n    }\n  }\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/theme/theme1/common/components/ContactRightPartTheme.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/theme/theme1/common/components/ContactRightPartTheme.css
// module chunks = 120